import { defaultFairnessCopy, FAIRNESS_EXPLANATION } from "@loot-os/api-contract";
import type { FairnessContent } from "@loot-os/design-system/templates/fairness/fairnessContent";

import { useFairnessSeedContent } from "./content/seed.js";
import { useFairnessVerifyContent } from "./content/verify.js";

/**
 * The public fairness surface, the same under every template; no key or session required:
 * `GET /v1/fairness/seeds/:date`, `GET /v1/opens/:id/verification`, and a full in-browser
 * recomputation of the roll through `@loot-os/client/verify`. The headings, fields and actions are
 * the store's default copy (`defaultFairnessCopy`); what the page says of the algorithm, the
 * verdicts and the facts are the platform's (`fairnessReadout.ts`), as are the refusals.
 */
export function useFairnessContent(): FairnessContent {
  return {
    intro: { title: defaultFairnessCopy().intro.title, body: FAIRNESS_EXPLANATION.intro },
    verify: useFairnessVerifyContent(),
    seed: useFairnessSeedContent(),
  };
}
